<div class="glxy-sticky-footer-content">
  <div class="glxy-sticky-footer-primary">
    <ng-content></ng-content>
  </div>
  <ng-content select="glxy-sticky-footer-secondary, [glxyStickyFooterSecondary]"> </ng-content>
</div>
